<template>
  <article>
    <section class="xbed-sub-title">
      <span>智能硬件管理</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>智能门锁管理</BreadcrumbItem>
        <BreadcrumbItem>门锁管理</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section style="margin-top:20px">
      <Form inline>
        <FormItem label="门店" :label-width="80">
          <Select ref="resetChain" v-model="search.chainId" clearable filterable placeholder="id/名称 输入下拉选择" style="width:200px;">
            <Option v-for="(item, index) in allChains" :value="item.chainId" :key="index">{{ `${item.chainId}_${item.chainName}` }}</Option>
          </Select>
        </FormItem>
        <FormItem label="门锁id" :label-width="80">
          <Input v-model="search.lockId" :maxlength="11" style="width: 118px"></Input>
        </FormItem>
        <FormItem label="房间id" :label-width="80">
          <Input v-model="search.roomId" :maxlength="11" style="width: 118px"></Input>
        </FormItem>
        <FormItem label="房号" :label-width="50">
          <Input v-model="search.custRoomNo" :maxlength="50" style="width: 118px"></Input>
        </FormItem>
        <FormItem label="门锁/盒子编码" :label-width="105">
          <Input v-model="search.lockInfo" :maxlength="50"></Input>
        </FormItem>
        <FormItem label="是否启用" :label-width="80">
          <Select v-model="search.stat" style="width: 120px">
            <Option :value="-1">全部</Option>
            <Option :value="0">已停用</Option>
            <Option :value="1">已启用</Option>
          </Select>
        </FormItem>
        <FormItem label="房间名" :label-width="80">
          <Input v-model="search.roomName" :maxlength="255"></Input>
        </FormItem>
        <FormItem label="门锁型号" :label-width="80">
          <Select v-model="search.lockModelId" style="width: 200px">
            <Option :value="-1">全部</Option>
            <Option v-for="item in lockModelList" :key="item.id" :value="item.lockModelId">{{item.modelName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="电量状态" :label-width="80">
          <Select v-model="search.isLowBattery" style="width: 120px">
            <Option :value="-1">全部</Option>
            <Option :value="0">正常</Option>
            <Option :value="1">低电量</Option>
          </Select>
        </FormItem>
        <FormItem label="网络状态" :label-width="80">
          <Select v-model="search.lockNetworkState" style="width: 120px">
            <Option :value="-1">全部</Option>
            <Option :value="0">无网络</Option>
            <Option :value="1">正常</Option>
          </Select>
        </FormItem>
        <FormItem label="售卖状态" :label-width="80">
          <Select v-model="search.flag" style="width: 120px">
            <Option :value="-1">全部</Option>
            <Option :value="1">上架展示</Option>
            <Option :value="2">已删除</Option>
            <Option :value="3">已下架</Option>
            <Option :value="4">筹建中</Option>
            <Option :value="5">售前展示</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changePage(1)">查询</Button>
        </FormItem>
         <FormItem :label-width="50">
          <Button type="primary" @click="exportExcle">导出筛选结果</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="downloadModal=true">批量导入门锁</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="addLockBtn">新增门锁</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="tbLockBtn" :loading="tbLoading">同步门锁信息</Button>
        </FormItem>
      </Form>
      <Table stripe :columns="columns" :data="lockList"></Table>
      <div style="margin: 10px;">
        <Page :total="page.total" show-sizer :current="page.page" :page-size="page.pageSize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
    </section>
    <Modal v-model="downloadModal" ref="downloadModal" title="批量导入门锁" :loading="true" @on-ok="uploadFileBtn">
      <Form label-position="left">
        <FormItem label="下载模板" :label-width="115">
          <Button @click="downLoadFile">点击下载</Button>
        </FormItem>
        <FormItem label="文件" :label-width="115">
          <Upload ref="uploadFileForm"
            :before-upload="handleBeforeUpload"
            :on-progress="xHandleLoading"
            :on-success="handleSuccess"
            :data="uploadData"
            :on-format-error="handleFormatError"
            :action="`${analysisUrl}door/lock/import`">
            <Button type="primary">选择文件</Button>
            <Tag v-if="currentFile.name" closable @on-close="handleClose">{{currentFile.name}}</Tag>
          </Upload>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="relateRoomModal" ref="relateRoomModal" :loading="true" title="关联房间" @on-ok="relateRoomBtn">
      <Form label-position="left" :model="relation" ref="relateForm" :rules="relateFormRule">
        <FormItem label="房间id" :label-width="85" prop="roomId">
          <Input v-model="relation.roomId" :maxlength="10"></Input>
        </FormItem>
        <FormItem label="安装日期" :label-width="85" prop="installTime">
          <DatePicker v-model="relation.installTime" type="date"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="netWorkOpenModal" ref="netWorkOpenModal" :loading="false" title="网络开门" @on-ok="netWorkOpenBtn">
      <Form label-position="left" :model="networkOpenObj" ref="networkForm" :rules="networkFormRule">
        <FormItem label="开门类型" :label-width="150" prop="openResult">
          <Select v-model="networkOpenObj.openResult">
            <Option value="1" >访客看房</Option>
            <Option value="2" >管家查房</Option>
            <Option value="3" >检修设备</Option>
            <Option value="4" >补充物资</Option>
            <Option value="5" >清洁打扫</Option>
            <Option value="6" >入住门锁异常</Option>
            <Option value="9" >其他</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" :label-width="150" prop="remark">
          <Input v-model="networkOpenObj.remark" type="textarea" :maxlength="200" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="addLockModal" ref="addLockModal" :loading="true" :title="addLockModalTitle" @on-ok="preAddLock">
      <Form :model="editModalObj" label-position="left" :rules="lockTypeValidate" ref="editForm">
        <FormItem label="门锁型号" :label-width="150" prop="lockModelId">
          <Select v-model="editModalObj.lockModelId" @on-change="handleModelLock">
            <Option v-for="item in lockModelList && lockModelList.filter(item => addLockModalTitle === '新增门锁' ? (item.lockModelId !== 9 && item.lockModelId !== 12) : true)" :key="item.lockModelId" :value="item.lockModelId">{{item.modelName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="门锁编码" :label-width="150" prop="lockSn">
          <Input v-model="editModalObj.lockSn" :maxlength="50" :disabled='editLockLockSn || editModalObj.lockModelId === 12'></Input>
        </FormItem>
        <FormItem label="网络盒子编码" :label-width="150" prop="netBoxSn" v-if="!editLock">
          <Input v-model="editModalObj.netBoxSn" :maxlength="50" :disabled="editModalObj.lockModelId === 12"></Input>
        </FormItem>
        <FormItem label="盒子编号" :label-width="150" prop="keySn" v-if="!editLock">
          <Input v-model="editModalObj.keySn" :maxlength="50" :disabled="editModalObj.lockModelId === 12"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
import Config from "../../../config";
import Moment from 'moment';
import {STORE_KEY} from "../../../constants"

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.analysisUrl = Config[this.env].analysisUrl;

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'group': 'dev' // 本地请求才需要加该参数
    }
    this.formHeaders = {
      'isForm': true,
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token")
    }
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryLockList();
    this.queryLockModel();
    this.getChainData();
  },
  data () {
    return {
      tbLoading: false, // 同步门锁按钮loading
      updateLockArr: [], // 把点击了更新状态的 lockId 放到数组中，显示 loading
      openLock1Arr: [], // 把点击了巡店开门的 roomId 放到数组中，显示 loading
      openLock2Arr: [], // 把点击了演示开门的 roomId 放到数组中，显示 loading
      openElecArr: [], // 把点击了电源的 roomId 放到数组中，显示 loading
      closeElecArr: [], // 把点击了电源的 roomId 放到数组中，显示 loading
      allChains: [],
      editLock:false,
      editLockLockSn:false,
      page: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      search: {
        chainId: "",
        lockId: "",
        roomId: "",
        lockInfo: "",
        roomName: "",
        lockModelId: -1,
        isLowBattery: -1,
        lockNetworkState: -1,
        flag: -1,
        stat: -1
      },
      relation: {
        roomId: '',
        date: '',
        lockId: ''
      },
      relateFormRule: {
        roomId: [
          { required: true, message: '请填写房间id', trigger: 'blur' },
          { pattern: '^[0-9]*$', message: '只能填入一个房间id（纯数字）', trigger: 'blur' },
        ],
        installTime: [
          { required: true, type: 'date', message: '请填写日期', trigger: 'change' }
        ]
      },
      lockModelList: [],
      lockList: [],
      currentFile: {},
      downloadModal: false,
      relateRoomModal: false,
      addLockModal: false,
      netWorkOpenModal: false,
      addLockModalTitle: '',
      editModalObj: {},
      networkOpenObj: {},
      editLockNo: '',
      editNetNo: '',
      editNo: '',
      editFormRule: {
        lockModelId: [
          { required: true, type: 'number', message: '请选择门锁型号', trigger: 'change' }
        ],
        lockSn: [
          { required: true, message: '请填写门锁编码', trigger: 'blur' }
        ],
        netBoxSn: [
          { required: true, message: '请填写网络盒子编码', trigger: 'blur' }
        ],
        keySn: [
          { required: true, message: '请填写盒子编号', trigger: 'blur' }
        ]
      },
      networkFormRule: {
        openResult: [
          { required: true, type: 'string', message: '请选择开门类型', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请填写备注', trigger: 'blur' }

        ]
      },
      editFormRuleKeySn: {
        lockModelId: [
          { required: true, type: 'number', message: '请选择门锁型号', trigger: 'change' }
        ],
        lockSn: [
          { required: true, message: '请填写门锁编码', trigger: 'blur' }
        ],
        netBoxSn: [
          { required: false, message: '请填写网络盒子编码', trigger: 'blur' }
        ],
        keySn: [
          { required: false, message: '请填写盒子编号', trigger: 'blur' }
        ]
      },
      editFormRuleModelId: {
        lockModelId: [
          { required: true, type: 'number', message: '请选择门锁型号', trigger: 'change' }
        ],
        lockSn: [
          { required: false, message: '请填写门锁编码', trigger: 'blur' }
        ],
        netBoxSn: [
          { required: false, message: '请填写网络盒子编码', trigger: 'blur' }
        ],
        keySn: [
          { required: false, message: '请填写盒子编号', trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: '门锁id',
          width: 120,
          fixed: 'left',
          align: 'center',
          render: (h, param) => {
            return h('a',{
              on: {
                click: () =>{
                  if(this.$router){
                    this.$router.push({path: "/app/smart-device/smart-lock-detail", query: { lockId: param.row.lockId, roomId: param.row.roomId }});
                  }else{
                    window.open(`#/Order/Reserve/lockDetailPage?lockId=${param.row.lockId}&roomId=${param.row.roomId}`, '_blank');
                  }
                }
              }
            },param.row.lockId)
          }
        },
        {
          title: '房间id',
          width: 120,
          align: 'center',
          key: 'roomId'
        },
        {
          title: '门锁型号',
          width: 200,
          align: 'center',
          key: 'lockModelName'
        },
        {
          title: '联网监控',
          width: 150,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, ['否','是'][param.row.isNetworkMonitor])
          }
        },
        {
          title: '蓝牙功能',
          width: 120,
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.isBluetooth ? '有' : '无')
          }
        },
        {
          title: '离线密码',
          width: 120,
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.supportOfflinePwd ? '有' : '无')
          }
        },
        {
          title: '密码功能',
          width: 120,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, ['订单密码','无密码','即时密码','离线密码'][param.row.pwdFunc])
          }
        },
        {
          title: '网络开门',
          width: 120,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, ['无','有'][param.row.isNetworkOpen])
          }
        },
        {
          title: '门锁编码',
          width: 120,
          align: 'center',
          key: 'lockSn'
        },
        {
          title: '网络盒子编码',
          width: 150,
          align: 'center',
          key: 'netBoxSn'
        },
        {
          title: '盒子编号',
          width: 120,
          align: 'center',
          key: 'keySn'
        },
        {
          title: '安装房间',
          width: 300,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, `${param.row.chainName||''}-${param.row.roomName||''}`)
          }
        },
        {
          title: '房间售卖状态',
          width: 150,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, ['','上架展示','删除','下架','筹建中','售前展示'][param.row.flag])
          }
        },
        {
          title: '安装时间',
          width: 200,
          align: 'center',
          key: 'installTime'
        },
        {
          title: '电量状态',
          width: 100,
          align: 'center',
          render: (h, param) => {
            if(param.row.isLowBattery == null) {
              return h('span', {}, '—')
            }else{
              return h('Tag', {
              props: {
                color:  param.row.isLowBattery ? 'red' : 'green'
              }
              }, 
              param.row.isLowBattery === 1 ? '低电量' : param.row.isLowBattery === 0 ? '正常' : '')
            }
          }  
        },
        {
          title: '门锁网络',
          width: 100,
          align: 'center',
          render: (h, param) => {
            if(param.row.lockNetworkState == null) {
              return h('span', {}, '—')
            }else{
              return h('Tag', {
                props: {
                  color: param.row.lockNetworkState ? 'green' : 'red'
                }
              }, 
              param.row.lockNetworkState ===1 ? '在线' :
              param.row.lockNetworkState ===0 ? '无网' : '')
            }
          }
        },
        {
          title: '网关网络',
          width: 100,
          align: 'center',
          render: (h, param) => {
            if(param.row.boxNetworkState == null) {
              return h('span', {}, '—')
            }else{
              return h('Tag', {
                props: {
                  color: param.row.boxNetworkState ? 'green' : 'red'
                }
              }, 
              param.row.boxNetworkState ===1 ? '在线' :
              param.row.boxNetworkState ===0 ? '无网' : '')
            }
          }
        },
        {
          title: '启用状态',
          width: 100,
          align: 'center',
          render: (h, param) => {
            // if([8,9,10,11].includes(param.row.lockModelId)) {
            //   return h('span', {}, '—')
            // }
            return h('Tag', {
              props: {
                color: param.row.stat ? 'green' : 'red'
              }
            }, param.row.stat ? '启用' : '停用')
          }
        },
        {
          title: '操作',
          width: 180,
          fixed: 'right',
          align: 'center',
          render: (h, param) => {
            let ch = [
              h('Button', {
                props: {
                  size: 'small',
                  type: 'info'
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    this.editModalObj = {
                      lockId: param.row.lockId,
                      lockModelId: param.row.lockModelId,
                      lockSn: param.row.lockSn,
                      netBoxSn: param.row.netBoxSn,
                      keySn: param.row.keySn,
                      stat: param.row.stat
                    }
                    this.editLockNo = param.row.lockSn
                    this.editNetNo = param.row.netBoxSn
                    this.editNo = param.row.keySn
                    this.resetField()
                    this.addLockModalTitle = '修改门锁'
                    this.addLockModal = true;
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  size: 'small',
                  type: 'primary'
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    if(param.row.relationId) {
                      this.$Modal.confirm({
                        title: '消息提醒',
                        content: `<p>确定<span class="fontTipsRed">解除</span><span class="fontTipsblue">${param.row.roomName}</span>吗？</p><p>一经确定将<span class="fontTipsRed">无法修改</span></p>`,
                        onOk: () => {
                            this.unbindRoomRelation(param.row.relationId)
                        }
                      });
                    }else{
                      this.relation = {
                        chainName: '',
                        roomName: '',
                        installTime: param.row.installTime,
                        roomId: '',
                        lockId: param.row.lockId
                      }
                      this.relateRoomModal = true;
                    }
                  }
                }
              }, param.row.relationId ? '解除关联' : '关联房间'),
              h('Button', {
                props: {
                  size: 'small',
                  type: param.row.stat ? 'error' : 'success'
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: 'Title',
                      content: `<p>确定<span style="background-color:red;color:aliceblue">${param.row.stat?'停用':'启用'}</span><span style="background-color:cornflowerblue;color:aliceblue">${param.row.lockModelName}-${param.row.lockSn}<span>吗？</p><p>一经确定<span style="background-color:red;color:aliceblue">无法修改<span></p>`,
                      onOk: () => {
                        this.editModalObj = {
                          lockId: param.row.lockId,
                          lockModelId: param.row.lockModelId,
                          lockSn: param.row.lockSn,
                          netBoxSn: param.row.netBoxSn,
                          keySn: param.row.keySn,
                          stat: param.row.stat? 0 : 1
                        },
                        this.updataLock();
                      },
                    });
                  }
                }
              }, param.row.stat ? '停用' : '启用'),
              h('Button', {
                props: {
                  size: 'small',
                  type: 'success',
                  loading: this.updateLockArr.length && this.updateLockArr.includes(param.row.lockId) ? true : false
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    this.updateLockArr.push(param.row.lockId)
                    this.refreshLockState(param.row)
                  }
                }
              }, '更新状态')
            ]

            if(param.row.roomId !== null && this.checkHasPermission('oms_lock_openRoomLock.do')) {
              ch.push(h('Button', {
                props: {
                  size: 'small',
                  type: 'primary',
                  loading: false
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                      this.networkOpenObj = {
                        openResult: '2',
                        roomId: param.row.roomId,
                        remark: ''
                      }
                      this.netWorkOpenModal = true;
                  }
                }
              }, '网络开门'))
              ch.push(h('Button', {
                props: {
                  size: 'small',
                  type: 'success',
                  loading: this.openLock1Arr.length && this.openLock1Arr.includes(param.row.roomId) ?  true : false
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    this.openLock1Arr.push(param.row.roomId)
                    this.openLockAndElecComfirm(param.row, this.openLock1Arr, '巡店')
                  }
                }
              }, '巡店'))
            }
            if(param.row.roomId !== null && this.checkHasPermission('oms_lock_visitOpen')) {
              ch.push(h('Button', {
                props: {
                  size: 'small',
                  type: 'success',
                  loading: this.openLock2Arr.length && this.openLock2Arr.includes(param.row.roomId) ? true : false
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    this.openLock2Arr.push(param.row.roomId)
                    this.openLockAndElecComfirm(param.row, this.openLock2Arr, '参观')
                  }
                }
              }, '参观'))
            }
            if(param.row.roomId !== null && this.checkHasPermission('oms_lock_openRoomLock.do')) {
              ch.push(h('Button', {
                props: {
                  size: 'small',
                  type: 'success',
                  loading: this.openElecArr.length && this.openElecArr.includes(param.row.roomId) ? true : false
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    this.openElecArr.push(param.row.roomId)
                    this.openLockAndElecComfirm(param.row, this.openElecArr, '通电')
                  }
                }
              }, '通电'))
            }
            if(param.row.roomId !== null && this.checkHasPermission('oms_lock_openRoomLock.do')) {
              ch.push(h('Button', {
                props: {
                  size: 'small',
                  type: 'success',
                  loading: this.closeElecArr.length && this.closeElecArr.includes(param.row.roomId) ? true : false
                },
                style: {
                  margin: '5px'
                },
                on: {
                  click: () => {
                    this.closeElecArr.push(param.row.roomId)
                    this.openLockAndElecComfirm(param.row, this.closeElecArr, '断电')
                  }
                }
              }, '断电'))
            }

            // if([8,9,10,11].includes(param.row.lockModelId)){
            //   ch.length = 2
            // }
            return h('div', ch)
          }
        },
      ],
      format: ['xls','xlsx'],
      uploadData: {
        omsUserName: ''
      }
    }
  },
  computed:{
    lockTypeValidate(){
      switch(this.editModalObj.lockModelId){
        case 8:this.editLock=true;this.editLockLockSn=false;return this.editFormRuleKeySn
        case 9:this.editLock=this.editLockLockSn=true;return this.editFormRuleModelId
        case 10:this.editLock=true;this.editLockLockSn=false;return this.editFormRuleKeySn
        case 11:this.editLock=true;this.editLockLockSn=false;return this.editFormRuleKeySn
        default:this.editLock=this.editLockLockSn=false;return this.editFormRule
      }
      
    }
  },
  methods: {
    changePage(page) {
      this.page.page = page;
      this.queryLockList();
    },
    changePageSize(pageSize) {
      this.page.page = 1;
      this.page.pageSize = pageSize;
      this.queryLockList();
    },
    addLockBtn() {
      this.editModalObj = {
        lockModelId: this.lockModelList[0].lockModelId,
        lockSn: '',
        netBoxSn: '',
        keySn: ''
      },
      this.addLockModalTitle = '新增门锁'
      this.addLockModal = true;
      this.resetField()
    },
    downLoadFile() {
      let url = `${this.analysisUrl}door/lock/download/template`;
      window.open(url)
    },
    handleClose() {
      this.currentFile = {}
    },
    handleBeforeUpload(file) {
      if(this.handleFormatError(file)){
        this.uploadData.omsUserName = this.username
        this.currentFile = file;
      }
      return false;
    },
    uploadFileBtn() {
      if(!this.currentFile.name){
        this.$Notice.error({
          title: '请选择excel文件'
        })
        this.$refs.downloadModal.buttonLoading = false;
        return
      }
      this.$refs.uploadFileForm.post(this.currentFile);
      this.downloadModal = false;
    },
    handleFormatError(file) {
      if (this.format.length) {
        const _file_format = file.name.split('.').pop().toLocaleLowerCase();
        const checked = this.format.some(item => item.toLocaleLowerCase() === _file_format);
        if (!checked) {
          this.$Notice.error({
            title: "不支持的文件格式",
            desc: '请选择.xls, .xlsx格式的文件'
          })
          return false;
        }
        return true
      }
    },
    handleSuccess(res) {
      this.$Spin.hide();
      if(res.retCode != 21020000) {
        this.$Notice.error({
          title: '批量导入失败',
          desc: res.msg
        })
        return
      }
      this.$Notice.success({
        title: '批量导入成功'
      });
      this.queryLockList();
    },
    xHandleLoading(){
      this.$Spin.show()
    },
    resetField(){
      this.$refs.editForm.resetFields();
    },
    preAddLock() {
      this.$refs.addLockModal.buttonLoading = false;
        if(this.editLockLockSn){
          this.$Notice.error({
            title: '修改失败',
            desc:'艾电创新门锁无法修改！'
          });
          return
        }
      this.$refs.editForm.validate(valid => {
        if(valid) {
          if(!this.editModalObj.lockId){
            this.addLock();
          }else{
            this.updataLock();
          }
        }
      })
    },
    async netWorkOpenEvent() {
        var params = {
            handlerName: this.username,
            openType: this.networkOpenObj.openResult || '1',
            orderNo: '',
            roomId: this.networkOpenObj.roomId,
            remark: this.networkOpenObj.remark || '',
            type: '3'
        }
        let data = (await API.omsAPI[this.env].order.omsRemoteOpenDoor(params, this.token)).data;
        if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200) {
            this.$Notice.error({
              title: '网络开门失败',
              desc: data.msg
            })    
            return '';
        } else {
          this.$Notice.success({
            title: '网络开门成功',
          })
          this.netWorkOpenModal = false;
        }
    },
    netWorkOpenBtn() {
      this.$refs.netWorkOpenModal.buttonLoading = true;
      this.$refs.networkForm.validate(valid => {
        if(valid) {
          this.netWorkOpenEvent()
        }
      })
    },
    relateRoomBtn() {
      this.$refs.relateRoomModal.buttonLoading = false;
      this.$refs.relateForm.validate(valid => {
        if(valid) {
          this.relateRoomEvent()
        }
      })
    },openLockAndElecComfirm(obj, openLockArr, remark) {
      if (!this.checkHasPermission('oms_lock_openRoomLock.do')) {
        return;
      }

      var minutes = 10 
      if(remark == "参观"){
        minutes = 15
      }
      var content = `<p>确定立即${remark},${minutes}分钟后自动断电？</p><p>历史通电会立即失效，请谨慎操作!</p>`
      if(remark == "断电"){
        content = `<p>确定立即${remark}？</p><p>历史通电会立即失效，请谨慎操作!</p>`
      }
      this.$Modal.confirm({
        title: '消息提醒',
        content: content,
        onOk: () => {
          if(remark === '通电' || remark === '断电'){
            this.openElec(obj, openLockArr, remark, minutes)
          }else{
            this.openLockAndElec(obj, openLockArr, remark, minutes)
          }
        },
        onCancel: () => {
          openLockArr.map((item, index) => {
            if (item === obj.roomId) {
              openLockArr.splice(index, 1)
            }
          })
        }
      })
    },
    exportExcle() {
      let param = this.computedParam(this.search);
      let paramObj = {
        search: param
      };
      let url = `${Config[this.env].phpUrl}/Interface/index.php/Home/Reserve/exportLockList?json_data=${JSON.stringify(paramObj)}`;
      window.open(url);
    },
    computedParam(obj) {
      let param = Object.assign({}, obj);
      (param.isLowBattery === -1) && (param.isLowBattery = '');
      (param.lockNetworkState === -1) && (param.lockNetworkState = '');
      (param.flag === -1) && (param.flag = '');
      (param.stat === -1) && (param.stat = '');
      (param.lockModelId === -1) && (param.lockModelId = '');

      // 门锁id 房间id  如果不为空且有空格，需要去除
      (param.lockId) && (param.lockId = param.lockId.replace(/\s/g, ''));
      (param.roomId) && (param.roomId = param.roomId.replace(/\s/g, ''));

      Object.keys(param).forEach(function(key){
        param[key]==='' && (delete param[key]);
      });
      return param
    },
    async queryLockList() {
      let param = this.computedParam(this.search);
      let resp = (await API.omsAPI[this.env].deviceModule.queryAllLock(
        {
          page: this.page.page,
          size: this.page.pageSize,
          filter: JSON.stringify(param),
          orderBy: "lockId",
          sort: "desc",
        },
        this.token
      )).data; 
      if(resp.retCode){
        this.$Notice.error({
          title: '查询失败',
          desc: resp.msg
        })
        return
      }
      this.page.total = resp.total;
      this.lockList = resp.content
    },
    async queryLockModel() {
      let resp = (await API.omsAPI[this.env].deviceModule.queryLockModel(this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取门锁型号失败',
          desc: resp.msg
        })
        return
      }
      this.lockModelList = resp.lockModelList;
      this.editModalObj.lockModelId = resp.lockModelList[0].lockModelId;
    },
    async addLock() {
      let resp = (await API.omsAPI[this.env].deviceModule.addLock(
        this.editModalObj.keySn?this.editModalObj.keySn:'',
        this.editModalObj.lockModelId,
        this.editModalObj.lockSn?this.editModalObj.lockSn:'',
        this.editModalObj.netBoxSn?this.editModalObj.netBoxSn:'',
        this.username,
        this.token
      )).data
      if(resp.retCode){
        this.$Notice.error({
          title: '添加门锁失败',
          desc: resp.msg
        })
        return
      }
      this.addLockModal = false;
      this.$Notice.success({
        title: '添加成功',
      })
      this.queryLockList();
    },
    async updataLock() {
      let params = {
          lockId: this.editModalObj.lockId,
          lockModelId: this.editModalObj.lockModelId,
          
          stat: this.editModalObj.stat,
          updater: this.username,
        }
        if(this.editModalObj.keySn) params.keySn=this.editModalObj.keySn
        if(this.editModalObj.netBoxSn) params.netBoxSn=this.editModalObj.netBoxSn
        if(this.editModalObj.lockSn) params.lockSn=this.editModalObj.lockSn

      let resp = (await API.omsAPI[this.env].deviceModule.updataLock(
        params,
        this.token
      )).data
      if(resp.retCode) {
        this.$Notice.error({
          title: '修改失败',
          desc: resp.msg
        })
        return
      }
      this.addLockModal = false;
      this.$Notice.success({
        title: '修改成功',
      });
      this.queryLockList();
    },
    checkHasPermission( name ) {
      console.log("checkHasPermission", name)
      console.log("checkHasPermission-showAllPremission", Utils.showAllPremission())
      if ( !Utils.hasPermission( name ) ) {
        this.$Notice.error( {
          title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
        } );

        return false;
      }
      return true;
    },
    async openLockAndElec(obj, openLockArr, remark, minutes) {
      var username = localStorage.getItem('vue-username');
      var params = {
        handlerName: '【OMS】' + username,
        openType: '1',
        orderNo: '',
        remark: remark + '开门',
        roomId:  obj.roomId,
        type: '3'
      }
      var token = localStorage.getItem('vue-token');
      var env = Utils.findFromLocalStorage("env", "dev");
      API.omsAPI[env].order.omsRemoteOpenDoor(params, token).then((res) => {
        var data = res.data;
        openLockArr.map((item, index) => {
          if (item === obj.roomId) {
            openLockArr.splice(index, 1)
          }
        })
        if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200) {
          this.$Notice.error({
            title: '开门' + data.msg
          });
        } else {
          var endTime = Moment().add(minutes,'minutes').format('YYYY-MM-DD HH:mm:00')
          var elecParams = {
            reson: remark + '通电',
            remark: remark + '通电',
            roomId:  obj.roomId,
            operator:'【OMS】' + username,
            endTime: endTime,
            powerStatus: '1',
            statusType: 1
          }
          API.omsAPI[env].clientServer.applyElec(elecParams, this.formHeaders).then((res) => {
            var data = res.data;
            if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200 && data.msg !== '房间数据未同步') {
              this.$Notice.error({
                title: '通电' + data.msg
              });
            } else {
              this.$Notice.success({title: "操作成功"})
            }
          })
        }
      })
    },
    async openElec(obj, openArr, remark, minutes) {
      var endTime = Moment().add(minutes,'minutes').format('YYYY-MM-DD HH:mm:00')
      var username = localStorage.getItem('vue-username');
      var env = Utils.findFromLocalStorage("env", "dev");
      var elecParams = {
            reson: '电源' + remark,
            remark: '电源' + remark,
            roomId:  obj.roomId,
            operator:'【OMS】' + username,
            endTime: endTime,
            powerStatus: remark == '通电' ? 1 : 0,
            statusType: 1
          }
      API.omsAPI[env].clientServer.applyElec(elecParams, this.formHeaders).then((res) => {
        openArr.map((item, index) => {
          if (item === obj.roomId) {
            openArr.splice(index, 1)
          }
        })
        var data = res.data;
        if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200) {
          this.$Notice.error({
            title: data.msg
          });
        } else {
          this.$Notice.success({title: "操作成功"})
        }
      })
    },
    async refreshLockState(obj) {
      let resp = (await API.omsAPI[this.env].deviceModule.refreshLockState(obj.lockId, this.token)).data;
      // 更新成功后，把当前 lockId 从数组中移除
      this.updateLockArr.map((item, index) => {
        if (item === obj.lockId) {
          this.updateLockArr.splice(index, 1)
        }
      })
      if(resp.retCode){
        this.$Notice.error({
          title: '更新失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '更新成功'
      })
      obj = Object.assign(obj, resp);
    },
    async relateRoomEvent() {
      let resp = (await API.omsAPI[this.env].deviceModule.relateRoom(
        Moment(this.relation.installTime).format('YYYY-MM-DD'),
        this.relation.lockId,
        this.relation.roomId,
        this.relation.roomName,
        this.token
      )).data;
      if(resp.retCode) {
        this.$Notice.error({
          title: '关联失败',
          desc: `${resp.msg}${resp.data||''}`
        })
        return
      }
      this.$Notice.success({
        title: '关联成功'
      })
      this.relateRoomModal = false;
      this.queryLockList()
    },
    async unbindRoomRelation(id) {
      let resp = (await API.omsAPI[this.env].deviceModule.unbindRoomRelation(id, this.username, this.token)).data;
      if(resp.retCode) {
        this.$Notice.error({
          title: '解除失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '解除成功'
      });
      this.queryLockList()
    },
    handleModelLock(val) {
      if (val === 9 || val === 12) {
        this.editModalObj.lockSn = this.editLockNo
        this.editModalObj.netBoxSn = this.editNetNo
        this.editModalObj.keySn = this.editNo
      }
    },
    // 获取所有门店数据
    async getChainData () {
      const resp = (await API.omsAPI[this.env].cleaner.queryChainListForCleanOrder(this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "查询门店列表失败",
          desc: resp.msg
        });
        return
      }
      this.allChains = resp;
    },
    // 同步门锁功能
    async tbLockBtn() {
      this.tbLoading = true
      let resp1 = (await API.omsAPI[this.env].clientServer.scienerInit({}, this.protHeaders)).data;
      if ( resp1.retCode ) {
        this.$Notice.error( {
          title: '同步失败',
          desc: resp1.msg
        })
        this.tbLoading = false
        return
      }
      let resp2 = (await API.omsAPI[this.env].clientServer.scienerInitNet({}, this.protHeaders)).data;
      if ( resp2.retCode ) {
        this.$Notice.error( {
          title: '同步失败',
          desc: resp2.msg
        })
        this.tbLoading = false
        return
      }
      this.$Notice.success({
        title: '同步中，请5分钟后刷新页面'
      });
      this.tbLoading = false
      this.queryLockList()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/smart-device/samrt-lock/index.vue